import { render } from "./ZNBMredact.vue?vue&type=template&id=a034f7f6&scoped=true"
import script from "./ZNBMredact.vue?vue&type=script&lang=js"
export * from "./ZNBMredact.vue?vue&type=script&lang=js"

import "./ZNBMredact.vue?vue&type=style&index=0&id=a034f7f6&lang=scss&scoped=true"
import "./ZNBMredact.vue?vue&type=style&index=1&id=a034f7f6&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a034f7f6"]])

export default __exports__